<div class="content-container">
  <p><b>ID: </b>{{ student.id }}</p>
  <p><b>Email: </b>{{ student.email }}</p>
  <p><b>Role: </b>{{ student.role }}</p>

  <!-- <app-patient-table [patients]="patients" [loading]="isLoading"></app-patient-table> -->
  <p-table #patientTable [value]="patients" class="emr-table" styleClass="data-table" [loading]="isLoading"
    [rowHover]="true" [rows]="5" [rowsPerPageOptions]="[5, 10, 15]" responsiveLayout="scroll" [paginator]="true"
    [showCurrentPageReport]="true" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} patients"
    [filterDelay]="0">
    <ng-template pTemplate="caption"> Patients </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="mrn">
          <div class="flex justify-content-between align-items-center">
            MRN
            <p-sortIcon field="mrn"></p-sortIcon>
            <p-columnFilter type="text" field="mrn" display="menu" class="ml-auto"></p-columnFilter>
          </div>
        </th>
        <th pSortableColumn="id">
          <div class="flex justify-content-between align-items-center">
            ID
            <p-sortIcon field="id"></p-sortIcon>
            <p-columnFilter type="text" field="id" display="menu" class="ml-auto"></p-columnFilter>
          </div>
        </th>
        <th pSortableColumn="firstName">
          <div class="flex justify-content-between align-items-center">
            First Name
            <p-sortIcon field="firstName"></p-sortIcon>
            <p-columnFilter type="text" field="firstName" display="menu" class="ml-auto"></p-columnFilter>
          </div>
        </th>
        <th pSortableColumn="lastName">
          <div class="flex justify-content-between align-items-center">
            Last Name
            <p-sortIcon field="lastName"></p-sortIcon>
            <p-columnFilter type="text" field="lastName" display="menu" class="ml-auto"></p-columnFilter>
          </div>
        </th>
        <th pSortableColumn="dateCreated">
          <div class="flex justify-content-between align-items-center">
            Date Created
            <p-sortIcon field="dateCreated"></p-sortIcon>
          </div>
        </th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-patient>
      <tr class="p-selectable-row">
        <td>
          {{ patient.mrn }}
        </td>
        <td>
          {{ patient.id }}
        </td>
        <td>
          {{ patient.firstName }}
        </td>
        <td>
          {{ patient.lastName }}
        </td>
        <td>
          {{ patient.getDisplayDateCreated() }}
        </td>
        <td style="text-align: center">
          <button pButton type="button" class="p-button-primary" icon="pi pi-arrow-right" pTooltip="View patient"
            (click)="navigateToPatient(patient.id)"></button>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <td colspan="8" style="text-align: center; padding: 3rem">No patients assigned.</td>
    </ng-template>
  </p-table>
</div>